/* global globalThis */
import React, { /*useEffect,*/ useState } from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';

import { PopupTypes } from '../../../components/Popup';
import { DataTip, T } from '../../../components/Translations';
import { ApiUrl, AppPages } from '../../../project/Defines';
import { EVENT_NAME } from '../../../project/utilities';
import { COLUMN_TYPE } from '../../../Shared/ListView/helper';
import ListView from '../../../Shared/ListView';
import { Ajax } from '../../../components/Ajax';


/**
 * ContractAttachments list of ServiceContract
 * @exports ContractAttachments
 */
export default function ContractAttachments(props) {
    const listUpdateEvent = EVENT_NAME.ATTACHMENTS_CONTRACT_LIST_UPDATE;
    const { dataSource, setDataSource, disabled } = props;
    const isNewCall = !!dataSource;
    const service_contract_uuid = props.dataItem?.ID;
    const [staticFilter] = useState({ service_contract_uuid });
    const [detailProps] = useState({
        newTitle: 'text.create_new_attachment',
        editTitle: 'text.edit_attachment',
        fullScreen: false,
        popupType: PopupTypes.ContractAttachmentDetails,
        windowKey: 'wndContractAttachmentDetails',
        parentData: props.dataItem || {},
        isNewCall,
        setDataSource
    });

    const columnConfig = [
        {
            field: 'attachment_name',
            width: 50,
            render: (text, record) => {
                const url = record?.images?.[0]?.image_url;
                const imageName = record?.images?.[0]?.name && record?.images?.[0]?.image_guid;
                return (
                    <wrap>
                        <a /* eslint-disable-line jsx-a11y/anchor-is-valid */
                            onClick={() => {
                                //setRedirectUrl(url);
                                // Ajax.downloadGet({
                                //     url: url,
                                //     target: '_blank',
                                //     autoDownload: true,
                                //     absolute:true,
                                //     data: {
                                        
                                //     },
                                //     success: function (response) {
                                //     },
                                //     error: function (response) {
                                //     }
                                // });

                                Ajax.get({
                                url: url + `&fileSecondName=${record?.attachment_name}`,
                                absolute: true,
                                // data: { 
                                // },
                                success: function (response) {
                                  if (response) {
                                    globalThis.open(response, '_blank');
                                  } else {
                                    message.error("Attachment not found.");
                                  }
                                },
                                error: function (error) {
                                    message.error("Attachment not found.");
                                }
                              });
                            }}
                            style={{ display: 'flex' }}><DataTip title={imageName}><icon>eye</icon></DataTip></a> 
                        {/* <a href={url} target='_blank' style={{ display: 'flex' }}><DataTip title={imageName}><icon>eye</icon></DataTip></a> eslint-disable-line react/jsx-no-target-blank*/}
                    </wrap>
                );
            },

            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.attachment_name',
            field: 'attachment_name',
            type: COLUMN_TYPE.TEXT
        },
        {
            type: COLUMN_TYPE.ACTION,
        }
    ];

 

    return ( <ListView
            {...props}
            columnConfig={columnConfig}
            staticFilter={staticFilter}
            apiUrl={ApiUrl.ContractAttachmentsList}
            dataSource={dataSource}
            skipEdit
            listUpdateEvent={listUpdateEvent}
            detailProps={detailProps}
            deleteUrl={!disabled && ApiUrl.ContractAttachmentsDelete}
            skipNewButton={disabled}
            onCustomDelete={isNewCall && (rec => setDataSource(d => d.filter(at => at.ID !== rec.ID)))}
            newButtonTip={<T>text.create_new_attachment</T>}
            nameField='attachment_name'
            showRefreshButton={false}
            isSimple
            isChieldView
            listName={AppPages.ContractAttachments}
        />
    );
}

ContractAttachments.propTypes = {
    dataSource: PropTypes.array,
    setDataSource: PropTypes.func,
    disabled: PropTypes.bool,
    dataItem: PropTypes.object
};
